module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.25672",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.6308",
      "conversations-error-reporting": "static-1.7587",
      "conversations-internal-pub-sub": "static-1.14645",
      "conversations-internal-schema": "static-1.11284",
      "conversations-message-history": "static-1.9727",
      "conversations-test-sdk": "static-1.9120",
      "conversations-visitor-experience-components": "static-1.19035",
      "head-dlb": "static-1.3679",
      "hs-promise-utils": "static-1.4157",
      "hs-test-utils": "static-1.6638",
      "hubspot-dlb": "static-2.1317",
      "HubStyleTokens": "static-2.10132",
      "I18n": "static-7.1376",
      "jasmine-immutable": "static-1.1599",
      "jasmine-runner": "static-1.5040",
      "quartz": "static-1.5392",
      "react-aria": "static-1.38",
      "react-dlb": "static-1.51",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "transmute": "static-2.29",
      "urlinator": "static-1.3186",
      "viral-links-lib": "static-1.5507",
      "visitor-ui-component-library": "static-1.4829",
      "webpack-env": "static-1.54",
      "ably-hubspot-js": "static-2.3217",
      "atom": "static-1.3875",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.3438",
      "conversations-infrastructure": "static-1.7562",
      "conversations-prop-types": "static-1.6062",
      "conversations-visibility-tools": "static-1.4394",
      "conversations-visitor-message-history": "static-1.17772",
      "cssUtils": "static-1.463",
      "enviro": "static-4.293",
      "flux-actions": "static-1.267",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.4807",
      "hubspot-url-utils": "static-1.2969",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.8343",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.272",
      "raven": "static-3.4440",
      "react": "static-7.151",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.15231",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.4187",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.3018",
      "sanitize-text": "static-1.6822",
      "signup-constants": "static-1.15880",
      "styled-components": "static-2.40",
      "StyleGuideUI": "static-3.454",
      "usage-tracker": "static-1.6099",
      "usage-tracker-core": "static-1.5949",
      "usage-tracker-multi": "static-1.4513",
      "usage-tracker-public": "static-1.5910",
      "visitor-ui-component-library-icons": "static-1.4640",
      "hs-promise-rejection-tracking": "static-1.3967",
      "raven-hubspot": "static-1.4747",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.2303",
      "moment": "static-3.26",
      "quartz-core": "static-1.4611",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.3552",
      "foundations-components": "static-1.5801",
      "foundations-theming": "static-1.2945",
      "UIComponents": "static-3.7080",
      "conversations-skeleton-state": "static-1.6026",
      "cv-backend-services": "static-1.1110",
      "icons": "static-2.591",
      "react-input-autosize": "static-2.17",
      "ui-images": "static-2.807",
      "permission-components": "static-1.4010",
      "react-virtualized": "static-2.73",
      "HeadJS": "static-2.565",
      "framer-motion": "static-1.40",
      "hs-test-utils-bend-plugin": "static-1.1749",
      "msw": "static-1.39",
      "testing-library": "static-1.120",
      "i18n-data": "static-1.196",
      "moment-timezone": "static-5.51",
      "jasmine": "static-4.2982",
      "quartz-core-utils": "static-1.2259",
      "signup-ui-url-generator": "static-2.6683",
      "HubStyle": "static-2.10441",
      "sassPrefix": "static-1.129",
      "csstype": "static-1.38",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.4516",
      "copilot-toolkit": "static-1.5636",
      "dispatcher": "static-1.111",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.637",
      "hub-http-shared-msw-handlers": "static-1.6870",
      "hubspotter-http": "static-1.3440",
      "hubspotter-http-shared-msw-handlers": "static-1.6868",
      "mobile-manifest-mixins": "static-1.336",
      "platform-navigation-bootstrap": "static-1.11043",
      "quick-fetch": "static-1.2772",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.331",
      "hs-story-utils": "static-1.8029",
      "bend-plugin-foundations-components": "static-1.2069",
      "floating-ui": "static-1.28",
      "foundations-theming-specialty": "static-1.662",
      "tanstack-table": "static-1.23",
      "bend-plugin-foundations-theming": "static-1.1428",
      "foundations-theming-base": "static-1.1930",
      "rpc-client-utils": "static-1.3358",
      "ts-schema": "static-1.2999",
      "chatspot-client-types": "static-1.8340",
      "chatspot-core": "static-1.14866",
      "platform-infra-nav-components": "static-1.6550"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.25672",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.6308",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.7587",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.14645",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11284",
      "conversations-message-history": "/conversations-message-history/static-1.9727",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9120",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.19035",
      "head-dlb": "/head-dlb/static-1.3679",
      "hs-promise-utils": "/hs-promise-utils/static-1.4157",
      "hs-test-utils": "/hs-test-utils/static-1.6638",
      "hubspot-dlb": "/hubspot-dlb/static-2.1317",
      "HubStyleTokens": "/HubStyleTokens/static-2.10132",
      "I18n": "/I18n/static-7.1376",
      "jasmine-immutable": "/jasmine-immutable/static-1.1599",
      "jasmine-runner": "/jasmine-runner/static-1.5040",
      "quartz": "/quartz/static-1.5392",
      "react-aria": "/react-aria/static-1.38",
      "react-dlb": "/react-dlb/static-1.51",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "transmute": "/transmute/static-2.29",
      "urlinator": "/urlinator/static-1.3186",
      "viral-links-lib": "/viral-links-lib/static-1.5507",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.4829",
      "webpack-env": "/webpack-env/static-1.54",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3217",
      "atom": "/atom/static-1.3875",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.3438",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.7562",
      "conversations-prop-types": "/conversations-prop-types/static-1.6062",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.4394",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.17772",
      "cssUtils": "/cssUtils/static-1.463",
      "enviro": "/enviro/static-4.293",
      "flux-actions": "/flux-actions/static-1.267",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.4807",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.2969",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.8343",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.272",
      "raven": "/raven/static-3.4440",
      "react": "/react/static-7.151",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.15231",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.4187",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.3018",
      "sanitize-text": "/sanitize-text/static-1.6822",
      "signup-constants": "/signup-constants/static-1.15880",
      "styled-components": "/styled-components/static-2.40",
      "StyleGuideUI": "/StyleGuideUI/static-3.454",
      "usage-tracker": "/usage-tracker/static-1.6099",
      "usage-tracker-core": "/usage-tracker-core/static-1.5949",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.4513",
      "usage-tracker-public": "/usage-tracker-public/static-1.5910",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.4640",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.3967",
      "raven-hubspot": "/raven-hubspot/static-1.4747",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2303",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.4611",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.3552",
      "foundations-components": "/foundations-components/static-1.5801",
      "foundations-theming": "/foundations-theming/static-1.2945",
      "UIComponents": "/UIComponents/static-3.7080",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6026",
      "cv-backend-services": "/cv-backend-services/static-1.1110",
      "icons": "/icons/static-2.591",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "ui-images": "/ui-images/static-2.807",
      "permission-components": "/permission-components/static-1.4010",
      "react-virtualized": "/react-virtualized/static-2.73",
      "HeadJS": "/HeadJS/static-2.565",
      "framer-motion": "/framer-motion/static-1.40",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1749",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.120",
      "i18n-data": "/i18n-data/static-1.196",
      "moment-timezone": "/moment-timezone/static-5.51",
      "jasmine": "/jasmine/static-4.2982",
      "quartz-core-utils": "/quartz-core-utils/static-1.2259",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.6683",
      "HubStyle": "/HubStyle/static-2.10441",
      "sassPrefix": "/sassPrefix/static-1.129",
      "csstype": "/csstype/static-1.38",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.4516",
      "copilot-toolkit": "/copilot-toolkit/static-1.5636",
      "dispatcher": "/dispatcher/static-1.111",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.637",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6870",
      "hubspotter-http": "/hubspotter-http/static-1.3440",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6868",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.336",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11043",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.331",
      "hs-story-utils": "/hs-story-utils/static-1.8029",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2069",
      "floating-ui": "/floating-ui/static-1.28",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.662",
      "tanstack-table": "/tanstack-table/static-1.23",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1428",
      "foundations-theming-base": "/foundations-theming-base/static-1.1930",
      "rpc-client-utils": "/rpc-client-utils/static-1.3358",
      "ts-schema": "/ts-schema/static-1.2999",
      "chatspot-client-types": "/chatspot-client-types/static-1.8340",
      "chatspot-core": "/chatspot-core/static-1.14866",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6550"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};